// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Ul5I","content":"RecentSearches_content__eG_0s"};